// Import model
import { SubmissionCondition } from '../models/SubmissionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { SubmissionIndexedFields } from '../models/SubmissionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { SubmissionIndexedFieldsSerializer } from './SubmissionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SubmissionCondition - handles JSON serialization and deserialization with type validation
 */
export class SubmissionConditionSerializer {
  /**
   * Deserializes a JSON string into a SubmissionCondition instance
   */
  static deserialize(json: string): SubmissionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SubmissionCondition instance
   */
  static fromObject(obj: any): SubmissionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SubmissionCondition');
    }


    const instance: SubmissionCondition = {
      fieldName: obj['fieldName'] as SubmissionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SubmissionCondition instances
   */
  static deserializeArray(json: string): SubmissionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SubmissionCondition instance to a JSON string
   */
  static serialize(instance: SubmissionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SubmissionCondition instance to a plain object
   */
  static toObject(instance: SubmissionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of SubmissionCondition instances to a JSON string
   */
  static serializeArray(instances: SubmissionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
